/* Built In Imports */
import { useState } from 'react';
/* External Imports */
import { Box, Image, Text, Flex, List } from '@chakra-ui/react';
import { nanoid } from 'nanoid';
import Slider from 'react-slick';

/* Internal Imports */
/* Components */
import SectionTitle from '@components/Headings/SectionTitle';
import config from '@config';

/* Services */
/* Styles */
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import MsrSectionTitle from '@msr/components/Headings/MsrSectionTitle';

/**
 * Renders the Sannidhi Testimonials content component
 * @param {Object} sectionContent - Data for section
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 * @returns {ReactElement} SuryaShaktiSharing content component
 */

const TestimonialsGroup = ({ sectionContent, region, language }) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [totalSlides, setTotalSlides] = useState(0);
    const [isSmallScreen, setIsSmallScreen] = useState(false);
    const handleInit = slider => {
        setTotalSlides(sectionContent[1]?.testimonials?.length);
    };
    const NextArrow = props => {
        const { onClick } = props;
        return (
            <Box
                pos="absolute"
                top="38%"
                zIndex="10"
                cursor="pointer"
                bgSize="20px"
                bgColor="#fff"
                border="solid 1px #f4f4f4"
                borderRadius="100%"
                w="62px"
                h="62px"
                boxShadow="0 0 7px 0 rgb(0 0 0 / 13%)"
                bgPos="center"
                bgRepeat="no-repeat"
                color="transparent"
                bgImage={`url('${config.imgPath}/d/46272/1652294891-right-black-arrow.png')`}
                right="-70px"
                display={currentSlide + 3 === totalSlides ? 'none' : { base: 'none', md: 'none', lg: 'block' }}
                onClick={currentSlide !== totalSlides - 1 ? onClick : undefined}
            />
        );
    };
    const PrevArrow = props => {
        const { onClick } = props;
        return (
            <Box
                pos="absolute"
                top="38%"
                zIndex="10"
                cursor="pointer"
                bgSize="20px"
                bgColor="#fff"
                border="solid 1px #f4f4f4"
                borderRadius="100%"
                boxShadow="0 0 7px 0 rgb(0 0 0 / 13%)"
                w="62px"
                h="62px"
                bgPos="center"
                bgRepeat="no-repeat"
                color="transparent"
                bgImage={`url('${config.imgPath}/d/46272/1652294895-left-black-arrow.png')`}
                left={'-80px'}
                display={currentSlide === 0 ? 'none' : { base: 'none', md: 'none', lg: 'block' }}
                onClick={currentSlide !== 0 ? onClick : undefined}
            />
        );
    };

    const settings = {
        dots: true,
        speed: 100,
        autoplay: false,
        autoplaySpeed: 11000,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false,
        infinite: false,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
        onInit: handleInit,
        appendDots: dots => (
            <Box
                display={{ base: 'block', md: 'block', xl: 'block' }}
                // position="absolute"
                bottom={{ base: '0', md: '0', xl: '0' }}
            >
                <List margin="0px">{dots}</List>
            </Box>
        ),
        responsive: [
            {
                breakpoint: 834,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                },
            },
        ],
        customPaging: function (i) {
            return (
                <Text
                    cursor="pointer"
                    display="inline-block"
                    w={{ base: '10px', md: '14px' }}
                    h={{ base: '10px', md: '14px' }}
                    m={{ base: '0px', md: '0 8px' }}
                    bgColor="#c4c4c4"
                    borderRadius="50%"
                ></Text>
            );
        },
    };

    return (
        <Box
            id={'msr-testimonials-group'}
            mx="auto"
            background={'#03062C'}
            maxW={'1920px'}
            height={{ base: '670px', md: '825px' }}
            mb={{ base: '30px', md: "90px" }}
        //   marginTop={{base:'0', "2xl":'-58px'}}
        >
            <Box mt={{md: '-80px', lg: '-20px'}} pt={{ base: '10px', md: '20px', "xl": '0px' }} pb={{ base: '20px', md: '50px' }} className='sharing'>
                {/* <SectionTitle titleObj={sectionContent?.[0]?.title?.[0]} color={'#F8E9D5'} dividerUrl={'https://static.sadhguru.org/d/46272/1744106053-suryashaktidivider2.png'} /> */}
                <MsrSectionTitle
                    titleObj={sectionContent?.[0]}
                    pageName="tamilthembu"
                    lang={language}
                />
            </Box>
            <Box
                maxW="100%"
                m="0 auto 0 auto"
                overflow="hidden"
                p={{ base: '10px 0px 0 10px', md: '35px 0px 0 50px' }}
                w={{ base: '100%', md: '1920px' }}
            >
                <Slider className='slick-slider' {...settings} m="0"  >
                    {sectionContent[1]?.testimonials?.map((data, i) => {
                        return (
                            <Box
                                p={{ base: '0px 12px', md: '0' }}
                                key={nanoid()}
                                textAlign="left"
                                fontFamily={'FedraSansStd-book'}
                                fontSize="17px"
                                lineHeight="27px"
                                display="flex"
                                alignItems={'stretch'}
                                margin={{ base: '0 0 30px 0', md: '0' }}
                                flexDirection={'column'}
                                flex={'1'}
                                className="singlecard"
                                mb={{ base: '0px', md: '10px' }}
                                maxWidth={{ base: '300px', md: '296px' }}
                                maxHeight={{ base: '417px', md: '446px' }}
                            >
                                <Box
                                    position={'relative'}
                                    as="div"
                                    display="flex"
                                    flexDirection="column"
                                    justifyContent="flex-start"
                                // background={'#FFFFFF'}
                                // boxShadow="0px 3px 3px 0px #0000001A"
                                // borderRadius={'6px'}
                                >
                                    <Box as="div" textAlign="center">
                                        <Image
                                            loading="lazy"
                                            src={data?.photo?.url}
                                            width={{ base: "277px", md: '342px' }}
                                            title={data?.photo?.title}
                                            alt={data?.photo?.alt}
                                            height={{ base: '418px', md: 'auto' }}
                                            padding={0} margin={0}
                                        />
                                    </Box>
                                    <Box
                                        position={'absolute'}
                                        top={{ base: '200px', md: '276px' }}
                                        as="div"
                                        p="10px"
                                        left={{ base: '10px', md: '0px' }}
                                        fontFamily={'FedraSansStd-book'}
                                        color="#fff"
                                        fontWeight={'400'}
                                        textAlign={'left'}
                                        fontSize={{ base: '16px', md: '16px' }}
                                        maxWidth={{ base: '277px', md: '296px' }}
                                        fontStyle={'italic'}
                                        lineHeight={{ md: '25px' }}
                                    >
                                        {data?.testimonialText}
                                        {data?.userName && (
                                            <Box
                                                fontStyle={'normal'}
                                                marginTop="15px"
                                                textAlign="left"
                                                color="#FFA735"
                                                fontWeight="700"
                                                fontFamily={'FedraSerifAStdBook'}
                                                fontSize={{ lg: '18px' }}
                                                lineHeight={{ md: '126%' }}
                                            >
                                                {data?.userName} <Text fontWeight={500} fontFamily={'FedraSansStd-book'} fontSize={{ md: '16px' }} color={'#fff'} >{data?.userDescription}</Text>
                                            </Box>
                                        )}
                                    </Box>
                                </Box>
                            </Box>
                        );
                    })}
                </Slider>
            </Box>
            <style jsx global>
                {`
            #msr-testimonials-group .slick-dots li p {
              margin-top: 1rem;
              background-color: #FFFFFF57;
            }
            #msr-testimonials-group .slick-dots li.slick-active p {
              background-color: #F5A147;
            }
            #msr-testimonials-group .slick-dots {
              position: relative;
              margin-top: 20px;
            }
            #msr-testimonials-group .sharing h2 {
              font-weight: 600;
            }
            #msr-testimonials-group  .singlecard {
              display: grid;
              grid-template-rows: auto 1fr auto;
              height: 100%;
            }
            #msr-testimonials-group .slick-slider {
              width: 940px;
              margin: 0 auto;
            }
            @media (max-width: 768px) {
              #msr-testimonials-group .slick-slider {
                width: 100%;
              }
              #msr-testimonials-group .slick-dots li {
                margin: 0;
              }
              #msr-testimonials-group .slick-prev,
              #msr-testimonials-group .slick-next {
                display: none !important;
              }
              #msr-testimonials-group .slick-list .slick-active {
                width: 297px !important;
              }
              #msr-testimonials-group .slick-dots {
                position: relative;
                margin-top: 10px;
              }
            }
          `}
            </style>
        </Box>
    );
};

export default TestimonialsGroup;